<form [formGroup]="form" (ngSubmit)="open()">
  <div class="edit-actions-cash-desk-open">
    <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction && !loading" matTooltip="Cancelar" type="button" (click)="close()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="!loadingAction && !loading" matTooltip="Generar" type="submit" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
  </div>
  <div *ngIf="loading" class="card-base"></div>
  <div class="card-base-actions">
    <div class="card-content-cash-desk-open-edit">
      <div class="card-container mat-elevation-z1">
        <div class="card-content">
          <mat-spinner *ngIf="loading"></mat-spinner>
          <div *ngIf="!loading" class="margin-right-small">
            <h3>Datos de apertura</h3>
            <mat-divider></mat-divider>
            <div class="aling-top medium-width margin-top-medium">
              <mat-form-field class="margin-right-small full-width">
                <mat-label>Monto neto a abonar</mat-label>
                <input matInput formControlName="CashDeskName" required>
                <mat-error *ngIf="f.CashDeskName.errors && f.CashDeskName.errors.required">
                  Ingrese el nombre la caja
                </mat-error>
              </mat-form-field>
              <mat-form-field class="margin-right-small full-width">
                <mat-label>Importe apertura</mat-label>
                <input type="number" matInput formControlName="OpenAmount" required>
                <mat-error *ngIf="f.OpenAmount.errors && f.CashDeskName.errors.required">
                  Ingrese el importe de apertura
                </mat-error>
              </mat-form-field>

              <mat-form-field class="full-width margin-botton-medium">
                <input type="text"
                       matInput placeholder="Usuario"
                       formControlName="UserFilter"
                       required [matAutocomplete]="autUser">
                <mat-autocomplete #autUser="matAutocomplete" [displayWith]="filterCompleteUser.displayFn">
                  <mat-option *ngFor="let userFilter of filteredUserOptions | async" [value]="userFilter">
                    {{userFilter.Name}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="f.UserFilter.errors && f.UserFilter.errors.required">
                  Seleccione un usuario
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
